import { render } from "./ShotJobComponent.vue?vue&type=template&id=70292512"
import script from "./ShotJobComponent.vue?vue&type=script&lang=js"
export * from "./ShotJobComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__